<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading"/>
    <!--    <div class="top">-->
    <!--      <span class="icon"-->
    <!--            @click="history"><img class="goHistory"-->
    <!--             src="../../../assets/image/08.png"-->
    <!--             alt=""></span>-->
    <!--      <span class="iconText">备课资源</span>-->
    <!--    </div>-->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/zhunBei'">学前准备</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">备课资源</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="系统资源">
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listData">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name"><img src="../../../assets/image/tubiao1.png" alt=""></span>
                        <span class="className">素养植根专家团队</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                        <!-- <span v-if="item.objectType==1"
                              class="sysRec">* 系统推荐</span> -->
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="use(item)"
                                  :disabled="item.selected==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <div class="prepare-content">
                          <p style="margin-top:10px;" v-if="item.content"><span v-html="item.content"></span></p>
                          <p v-if="!!item.detailContent"><span v-html="item.detailContent"></span></p>
                          <div v-if="item.imageList!=null" style="text-align:left;">
                            <!--                      <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                            <!--                        <a slot="customPaging" slot-scope="props">-->
                            <!--                          <img :src="resBasePath+'/'+item.imageList[props.i].path" />-->
                            <!--                        </a>-->
                            <!--                        <div v-for="img in item.imageList" :key="img.id">-->
                            <!--                          <img :src="resBasePath +'/'+ img.path" />-->
                            <!--                          <p v-if="img.name">{{img.name}}</p>-->
                            <!--                        </div>-->
                            <!--                      </a-carousel>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :images="item.imageList||[]"
                            ></rich-text-view>
                          </div>
                          <div class="videoDetail" v-if="item.videoList!=null" style="text-align:left;">
                            <!--                      <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                            <!--                        <a slot="customPaging" slot-scope="props">-->
                            <!--                          <img v-if="item.videoList[props.i].coverPath!=null" :src="resBasePath+'/'+item.videoList[props.i].coverPath" />-->
                            <!--                        </a>-->
                            <!--                        <div class="videoItem" v-for="i in item.videoList" :key="i.id" >-->
                            <!--                              <video v-if="i.path.split('.')[1]=='mp4'" class="videoPlay" controlslist="nodownload" :disablePictureInPicture="true" :src="resBaseVideo+'/'+i.path" controls="controls" :poster="resBasePath+'/'+i.coverPath"></video>-->
                            <!--                              <ts-video v-if="i.path.split('.')[1]=='m3u8'"  :poster="resBasePath+'/'+i.coverPath" :vPath="resBaseVideo+'/'+i.path"> </ts-video>-->
                            <!--                          </div>-->
                            <!--                      </a-carousel>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :videos="item.videoList||[]"
                            ></rich-text-view>
                          </div>
                          <div v-if="item.audioList!=null" style="text-align:left">
                            <!--                      <div class="audioDiv" v-for="audio in item.audioList" :key="audio.id">-->
                            <!--                        <audio controls class="audioWidth" :src="resBasePath+'/'+audio.path"/>-->
                            <!--                        <p v-if="audio.name">{{'音频'+audio.name}}</p>-->
                            <!--                      </div>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :audios="item.audioList||[]"
                            ></rich-text-view>
                          </div>
                          <a style="cursor: pointer">{{ item.readStyleId }}</a>
                          <!-- </div> -->
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                  <!-- <a-avatar class="avatar"
                            slot="avatar"
                            :src="resBasePath+'/'+item.photo" /> -->
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1" :page-size="pageSize"
                            @change="handleListChange"
                            :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="优质资源" force-render>
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listDatas">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name">{{ item.userName }} {{ item.school }}</span>
                        <span class="className">{{ item.className }}</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                        <!-- <span v-if="item.objectType==1"
                              class="sysRec">✨ 系统推荐</span> -->
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="use(item)"
                                  :disabled="item.selected2==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <div class="prepare-content">
                          <!-- <div v-for="item in listData" :key="item.id"> -->
                          <p style="margin-top:10px;" v-if="item.content"><span v-html="item.content"></span></p>
                          <p v-if="!!item.detailContent"><span v-html="item.detailContent"></span></p>
                          <div v-if="item.imageList!=null" style="text-align:left;;">
                            <!--                      <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                            <!--                        <a slot="customPaging" slot-scope="props">-->
                            <!--                          <img :src="resBasePath+'/'+item.imageList[props.i].path" />-->
                            <!--                        </a>-->
                            <!--                        <div v-for="img in item.imageList" :key="img.id">-->
                            <!--                          <img :src="resBasePath +'/'+ img.path" />-->
                            <!--                          <p v-if="img.name">{{img.name}}</p>-->
                            <!--                        </div>-->
                            <!--                      </a-carousel>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :images="item.imageList||[]"
                            ></rich-text-view>
                          </div>
                          <div class="videoDetail" v-if="item.videoList!=null" style="text-align:left;">
                            <!--                      <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                            <!--                        <a slot="customPaging" slot-scope="props">-->
                            <!--                          <img v-if="item.videoList[props.i].coverPath!=null" :src="resBasePath+'/'+item.videoList[props.i].coverPath" />-->
                            <!--                        </a>-->
                            <!--                        <div class="videoItem" v-for="i in item.videoList" :key="i.id" >-->
                            <!--                              <video v-if="i.path.split('.')[1]=='mp4'" class="videoPlay" controlslist="nodownload" :disablePictureInPicture="true" :src="resBaseVideo+'/'+i.path" controls="controls" :poster="resBasePath+'/'+i.coverPath"></video>-->
                            <!--                              <ts-video v-if="i.path.split('.')[1]=='m3u8'"  :poster="resBasePath+'/'+i.coverPath" :vPath="resBaseVideo+'/'+i.path"> </ts-video>-->
                            <!--                          </div>-->
                            <!--                      </a-carousel>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :videos="item.videoList||[]"
                            ></rich-text-view>
                          </div>
                          <div v-if="item.audioList!=null" style="text-align:left">
                            <!--                      <div class="audioDiv" v-for="audio in item.audioList" :key="audio.id">-->
                            <!--                        <audio controls class="audioWidth" :src="resBasePath+'/'+audio.path"/>-->
                            <!--                        <p v-if="audio.name">{{'音频'+audio.name}}</p>-->
                            <!--                      </div>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :audios="item.audioList||[]"
                            ></rich-text-view>
                          </div>
                          <a style="cursor: pointer">{{ item.readStyleId }}</a>
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                  <a-avatar class="avatar" slot="avatar"
                            :src="item.photo!=null?resBasePath+'/'+item.photo: './imgs/stu-photo.png'"/>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="用户资源">
          <div class="list">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listDatas_use">
              <a-list-item slot="renderItem"
                           key="item.title"
                           class="item"
                           slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <a-row>
                      <a-col :span="17">
                        <span class="name">{{ item.userName }} {{ item.school }}</span>
                        <span class="className">{{ item.className }}</span>
                      </a-col>
                      <a-col :span="7"
                             style="text-align:right;">
                        <!-- <span v-if="item.objectType==1"
                              class="sysRec">✨ 系统推荐</span> -->
                        <span class="useNum">已被使用 {{ item.useCount ? item.useCount : '0' }} 次</span>
                        <a-button class="useTo"
                                  @click="use(item)"
                                  :disabled="item.selected1==true?false:true">使用
                        </a-button>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <div class="prepare-content">
                          <!-- <div v-for="item in listData" :key="item.id"> -->
                          <p style="margin-top:10px;" v-if="item.content"><span v-html="item.content"></span></p>
                          <p v-if="!!item.detailContent"><span v-html="item.detailContent"></span></p>
                          <div v-if="item.imageList!=null" style="text-align:left;">
                            <!--                      <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                            <!--                        <a slot="customPaging" slot-scope="props">-->
                            <!--                          <img :src="resBasePath+'/'+item.imageList[props.i].path" />-->
                            <!--                        </a>-->
                            <!--                        <div v-for="img in item.imageList" :key="img.id">-->
                            <!--                          <img  :src="resBasePath +'/'+ img.path" />-->
                            <!--                          <p v-if="img.name">{{img.name}}</p>-->
                            <!--                        </div>-->
                            <!--                      </a-carousel>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :images="item.imageList||[]"
                            ></rich-text-view>
                          </div>
                          <div class="videoDetail" v-if="item.videoList!=null" style="text-align:left;">
                            <!--                      <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                            <!--                        <a slot="customPaging" slot-scope="props">-->
                            <!--                          <img v-if="item.videoList[props.i].coverPath!=null" :src="resBasePath+'/'+item.videoList[props.i].coverPath" />-->
                            <!--                        </a>-->
                            <!--                        <div class="videoItem" v-for="i in item.videoList" :key="i.id" >-->
                            <!--                              <video v-if="i.path.split('.')[1]=='mp4'" class="videoPlay" controlslist="nodownload" :disablePictureInPicture="true" :src="resBaseVideo+'/'+i.path" controls="controls" :poster="resBasePath+'/'+i.coverPath"></video>-->
                            <!--                              <ts-video v-if="i.path.split('.')[1]=='m3u8'"  :poster="resBasePath+'/'+i.coverPath" :vPath="resBaseVideo+'/'+i.path"> </ts-video>-->
                            <!--                          </div>-->
                            <!--                      </a-carousel>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :videos="item.videoList||[]"
                            ></rich-text-view>
                          </div>
                          <div v-if="item.audioList!=null" style="text-align:left">
                            <!--                      <div class="audioDiv" v-for="audio in item.audioList" :key="audio.id">-->
                            <!--                        <audio controls class="audioWidth" :src="resBasePath+'/'+audio.path"/>-->
                            <!--                        <p v-if="audio.name">{{'音频'+audio.name}}</p>-->
                            <!--                      </div>-->
                            <rich-text-view
                                :key="new Date().getTime()"
                                :content='item&&item.answerContent'
                                :audios="item.audioList||[]"
                            ></rich-text-view>
                          </div>
                          <a style="cursor: pointer">{{ item.readStyleId }}</a>
                          <!-- </div> -->
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                  <a-avatar class="avatar" slot="avatar"
                            :src="item.photo!=null?resBasePath+'/'+item.photo: './imgs/stu-photo.png'"/>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div style="text-align:center;margin:15px 0px;">
            <a-config-provider>
              <a-pagination :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            :total='total'/>
            </a-config-provider>
          </div>
        </a-tab-pane>
      </a-tabs>

    </div>
  </div>
</template>

<script>
// import HanIcon from '../components/Icon.vue'
import Card from '../components/card.vue'
import tsVideo from '../components/tsvideo.vue'
import RichTextView from "../../../components/richTextView.vue";

export default {
  name: 'PrepareRecommend',
  data() {
    return {
      loading: false,
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      total: 0,
      pageSize: 10,
      pageNum: 1,
      listData: [],
      listDatas: [],
      listDatas_use: [],
      indexNum: '',
      autoplay: true
    }
  },
  components: {
    Card,
    // HanIcon,
    tsVideo,
    RichTextView
  },
  created() {

  },
  watch: {
    mlVisible() {

    }
  },
  mounted() {
    this.getRecommendList()
    // this.getRecommendLists()
    // this.getRecommendLists_use()
  },
  methods: {
    callback(key) {
      switch (key) {
        case '1':

          this.getRecommendList()
          break
        case '2':

          this.getRecommendLists()
          break
        case '3':

          this.getRecommendLists_use()
          break
      }
    },
    history() {
      this.$router.go(-1)
    },
    handleListChange(current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getRecommendList()
    },
    getRecommendList(index) { // 资源推荐列表
      let _this = this
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: bookId,
        styleId: localStorage.getItem('styleId'),
        school: '',
        objectType: 1
      }
      // console.log(param)
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/study/getPrepareResourceRecommendList',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.listData = res.resultData.list.map((item, index) => ({...item, index}))
          _this.listData.forEach(item => {
            item['selected'] = true
            if (item.index == index) {
              item['selected'] = false
            }
          })
          _this.total = res.resultData.total
        }
      })
    },
    getRecommendLists(index) { // 资源推荐列表
      let _this = this
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: bookId,
        styleId: localStorage.getItem('styleId'),
        school: '',
        objectType: 5
      }
      // console.log(param)
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/study/getPrepareResourceRecommendList',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.listDatas = res.resultData.list.map((item, index) => ({...item, index}))
          _this.listDatas.forEach(item => {
            item['selected2'] = true
            if (item.index == index) {
              item['selected2'] = false
            }
          })
          _this.total = res.resultData.total
        }
      })
    },
    getRecommendLists_use(index) { // 资源推荐列表
      let _this = this
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        bookId: bookId,
        styleId: localStorage.getItem('styleId'),
        school: '',
        objectType: 3
      }
      // console.log(param)
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/study/getPrepareResourceRecommendList',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.listDatas_use = res.resultData.list.map((item, index) => ({...item, index}))
          _this.listDatas_use.forEach(item => {
            item['selected1'] = true
            if (item.index == index) {
              item['selected1'] = false
            }
          })
          _this.total = res.resultData.total
        }
      })
    },
    use(item) { //使用推荐资源
      this.indexNum = item.index
      const param = {
        id: item.id,
        userId: this.$getUserInfo().id
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/study/useOthersPreStudy',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('使用成功')
          this.getRecommendList(item.index)
          this.getRecommendLists(item.index)
          this.getRecommendLists_use(item.index)
        }
      })

    }
  }
}
</script>

<style lang="less" scoped>
.main {
  margin-left: -205px;
  // height: 110px;
  // background-color: #fff;
  // width: 100%;
  // height: 100%;
  .breadcrumb {
    width: 1240px;
    margin: auto auto;
  }

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .top {
    height: 50px;
    background-color: #fff;
    width: 1240px;
    margin: 0 auto;
    position: relative;

    .goHistory {
      width: 8px;
      height: 16px;
      cursor: pointer;
    }

    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }

    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 70px;
      color: #9d9292;
      font-size: 18px;
    }
  }

  .content {
    // max-height: 500px;
    // min-height: 1200px;
    // background: #fff;
    width: 1240px;
    margin: 20px auto;
    height: calc(100vh - 185px);


    .list{
      overflow-y: auto;
      height: calc(100vh - 305px);
    }

    .item {
      background: #F1F0F0;
      border-radius: 6px;
      padding: 20px;
      margin: 20px;
    }

    .name,
    .className,
    .useNum,
    .useTo {
      letter-spacing: 0px;
      color: #9d9292;
      font-size: 14px;

      img {
        width: 40px;
        height: auto;
      }
    }

    .className {
      margin-left: 10px;
    }

    .useTo {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .useTo1 {
      display: inline-block;
      width: 80px;
      height: 30px;
      background-color: @primary-color;
      color: #fff;
      margin-left: 20px;
    }

    .avatar {
      width: 25px;
      height: 25px;
    }

    .contentMes {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #040506;
      word-break: break-all;
    }

    .ulList {
      margin-top: 10px;

      .listMes {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #9d9292;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}

.sysRec {
  color: @primary-color;
  font-size: 14px;
  margin-right: 10px;
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-split .ant-list-item {
  //border-bottom: 10px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
  border-radius: 10px;
  background: #FFFFFF;
  margin-bottom: 10px;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  border-bottom: 10px solid #f1f0f0;
}

.prepare-content,
.task-item {
  width: 100%;
  height: 100%;
  // background-color: white;
  border-radius: @border-radius-base;
  font-size: 18px;
  color: #040506;
  white-space: pre-wrap;
  font-weight: normal;
  font-stretch: normal;
}

.videoDetail {
  .videoItem {
    display: inline-block;
    width: 640px;

    .videoPlay {
      width: 100%;
      height: 450px;
    }
  }
}

.audioDiv {
  margin: 10px 0px;

  .audioWidth {
    width: 500px;
  }
}

/deep/ .ant-carousel {
  text-align: center;
  width: 900px;
  margin: auto;
}

.videoItem {
  display: inline-block;
  width: 33%;
  margin: 0 auto;

  .videoPlay {
    width: 260px;
    height: 150px;
  }
}

.audioItem {
  display: inline-block;
  width: 33%;
  margin: 0 auto;
}

/deep/ .ant-carousel {
  text-align: center;
  width: 800px;
  margin: auto;
}

/deep/ .ant-carousel .slick-dots {
  height: auto;
}

/deep/ .ant-carousel .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  width: 100%;
  height: auto;
}

/deep/ .ant-carousel .slick-thumb {
  bottom: -45px;
}

/deep/ .ant-carousel .slick-thumb li {
  width: 60px;
  height: 45px;
}

/deep/ .ant-carousel .slick-thumb li img {
  border: 2px solid #CCC;
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

/deep/ .ant-carousel .slick-thumb li.slick-active img {
  border: 2px solid #db5647;
  filter: grayscale(0%);
}

/deep/ .ant-tabs-nav-scroll {
  border-bottom: 2px solid #F1F0F0;
}

/deep/ .ant-list-empty-text {
  background: #FFFFFF;
  border-radius: 10px;
}

/deep/ .ant-tabs {
  background: #FFFFFF;
  border-radius: 10px;
}
</style>
